"use client";
import React from "react";
import { FlozyLoader } from "../FlozyLoader";
import { Navbar } from "@/containers/Header/Navbar";


interface PageLoaderProps {
  isLoading?: boolean;
  className?: string;
  size?: "sm" | "md" | "lg";
  showHeader?: boolean;
}


export function PageLoader({ 
  isLoading = false, 
  className = "", 
  size = "md",
  showHeader = false
}: PageLoaderProps) {
  if (!isLoading) return null;

  return (
    <div className="h-screen w-full flex flex-col bg-background">
      {showHeader && (
        <div className="flex-shrink-0">
          <Navbar />
        </div>
      )}
      <div className="flex-1 flex items-center justify-center">
        <FlozyLoader isLoading={true} className={className} size={size} />
      </div>
    </div>
  );
}
